<template>
    <div>
        <div class="row">
          <div class="card transfer-summary">
            <div class="row" style="text-align: center;">
              <h3 class="center-align-mobile">{{ transferHeader }}</h3><br>
            </div>
            <div class="row">
              <div class="col m6 s6">
                <span data-t="Sending amount">{{ t("Sending amount") }}</span>
                <span data-t="Transfer fee">{{ t("Transfer fee") }}</span>
                <strong data-t="Payment processing fee">{{ t("Payment processing fee") }}</strong>
              </div>
              <div class="col m6 s6 right-align">
                <span> {{ model.AmountSent }} {{ model.SentCurrency }} </span>
                <span> {{ model.TransferFee }} {{ model.SentCurrency }} </span>
                <strong> {{ model.PaymentFee }} {{ model.SentCurrency }} </strong>
              </div>
            </div>
            <div class="row">
              <div class="col m6 s6">
                <span data-t="Your total">{{ t("Your total") }}</span>
                <span data-t="Receivable amount">{{ t("Receivable amount") }}</span>
              </div>
              <div class="col m6 s6 right-align">
                <b><span class="total"> {{ model.TotalChargedAmount }} {{ model.SentCurrency }}</span></b>
                <b><span>{{ model.AmountReceivable }} {{ model.ReceivingCurrency }}</span></b>
              </div>
            </div>
            <div class="row">
              <div class="col m6 s6">
                <div data-t="Exchange rate">{{ t("Exchange rate") }}</div>
              </div>
              <div v-if="model" class="col m6 s6 right-align" style="font-weight: bold">
                <span>1 {{ model.SentCurrency }} = {{ model.ExchangeRate }} {{ model.ReceivingCurrency }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-html="regulatoryInfo"/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {TransferSummaryModel} from './../Models/AmountsWithTransferSummaryModel';

export default defineComponent({
  name: "transferSummary",
  props: {
    model: Object as () => TransferSummaryModel,
    transferHeader: String,
    regulatoryInfo: String
  }
})
</script>

